
export default {
    name: 'LeeStep',
    inheritAttrs: false,
    inject: ['step'],
    data() {
        return {
            xh: '',
            total: ''
        }
    },
    mounted() {
        var children = this.$parent.$children
        this.xh = children.indexOf(this) + 1
        this.total = children.length

    },
    computed: {
        stepw() {
            if (!this.total) {
                return
            }
            var zhi = 100 / (this.total - 1)
            return zhi+'%'
        },
        maxw() {
            if (!this.total) {
                return
            }
            var zhi = 100 / this.total
            return zhi+'%'
        },
    },
    props: {
        title: {
            type: String,
            default: '' //默认default
        }
    }
};
